import { formatDateTime } from '../utils/dateFormat';

interface CardSidebarProps {
  card: any;
}

export function CardSidebar({ card }: CardSidebarProps) {
  return (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-lg p-6">
        <h3 className="text-lg font-bold text-white mb-4">Card Details</h3>
        <div className="space-y-3">
          <div>
            <p className="text-gray-400 text-sm">Due Date</p>
            <p className="text-white">{card.due ? formatDateTime(card.due) : 'No due date'}</p>
          </div>
          <div>
            <p className="text-gray-400 text-sm">Last Activity</p>
            <p className="text-white">{formatDateTime(card.date_last_activity)}</p>
          </div>
          <div>
            <p className="text-gray-400 text-sm">Position</p>
            <p className="text-white">{card.pos}</p>
          </div>
        </div>
      </div>

      <div className="bg-gray-800 rounded-lg p-6">
        <h3 className="text-lg font-bold text-white mb-4">Statistics</h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-400">Labels</span>
            <span className="text-white font-medium">{card.labels?.length || 0}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Checklists</span>
            <span className="text-white font-medium">{card.checklists?.length || 0}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Comments</span>
            <span className="text-white font-medium">{card.comments?.length || 0}</span>
          </div>
          {card.checklists && card.checklists.length > 0 && (
            <div className="flex justify-between">
              <span className="text-gray-400">Completed Items</span>
              <span className="text-white font-medium">
                {
                  card.checklists
                    .flatMap((c: any) => c.items || [])
                    .filter((i: any) => i.state === 'complete').length
                }{' '}
                / {card.checklists.flatMap((c: any) => c.items || []).length}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
